import { RootState } from 'store/rootReducer';
import { HeroTeaserDto } from 'cpes-common';
import { AbstractContentState } from '@cp-shared-19/frontend-integration';

export const NotFoundErrorPageContentSelector = (state: RootState): AbstractContentState<HeroTeaserDto> =>
    state.content.notFoundError;
